import { START_PAGE } from "../../utils/Constant";
import { GET_ALL_EVENT_DATA } from "./ActionTypes";

export const getAllEventData = (payload, currentPage = START_PAGE) => ({
    type: GET_ALL_EVENT_DATA,
    payload,
    currentPage,
  });